import {Button, Col, Container, Row} from "react-bootstrap";
import React from "react";
import {isDevelopmentBuild, isPreProd} from "../utils/constants";
import {identity} from "../utils/helpers";

export const ErrorMessage = ({
                                 resetError,
                                 componentStack,
                                 error: {message}
                             }: {
    error: Error,
    componentStack: string,
    eventId: string,
    resetError(): void
}) => {
    const {isInternalUser} = identity();
    return (
        <Container fluid className="">
            <Row>
                <Col>
                    <Row
                        className={`p-sm-5 w-100  position-absolute top-50 start-50 translate-middle ${(isDevelopmentBuild || isPreProd) && 'h-100'}`}>
                        <Col sm={6} className="d-sm-flex justify-content-end mt-2 mt-sm-5 mb-5 mb-sm-0">
                            <div className="text-center">
                                <h1 className="text-primary fs-1">Whoops!</h1>
                                <p className="fs-3">Something went wrong...</p>
                                <p className="fs-4">We are working hard to fix it!</p>
                                {isInternalUser &&
                                    <p>
                                        <Button variant="primary" onClick={() => resetError()} size="lg">
                                            Click here to reset!
                                        </Button>
                                    </p>
                                }
                            </div>
                        </Col>
                        <Col sm={6} className="d-flex d-sm-block flex-column align-items-center">
                            <img src="https://static.commerceplatform.services/content/img/pancake.jpg"
                                 width='259'
                                 height='462'
                                 className="img-fluid"/>
                        </Col>
                        {isInternalUser &&
                            <Col sm={12} className="text-center border-top pt-5 mt-3">
                                {(isDevelopmentBuild || isPreProd) && <pre>{message}</pre>}
                                {(isDevelopmentBuild || isPreProd) && <pre>{componentStack}</pre>}
                            </Col>
                        }
                    </Row>
                </Col>
            </Row>
        </Container>

    )
}